// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/serviceReceipt/stylesheets/refill.scss
 ** module id = 463
 ** module chunks = 1
 **/